module.exports = __webpack_public_path__ + "static/media/right-menu-tnc-icon.15760532.svg";